import { orchestrator } from 'satcheljs';
import { unselectCalendar } from 'owa-calendar-surface-select-calendar';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { onBeforeCalendarDelete } from 'owa-calendar-update';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Eventually should move to a more meaningful package closer to surface view store

orchestrator(onBeforeCalendarDelete, actionMessage => {
    const { calendar } = actionMessage;
    const foundSelectedCalendarResult = findInArray(getSelectedCalendars(), item => {
        return item.id.id == calendar.id.id;
    });
    if (foundSelectedCalendarResult) {
        // Unselect calendar if selected. We don't want to roll it back if action fails
        unselectCalendar(calendar);
    }
});
